import axiosInstance from "./AxiosConfig";

class SupportApi {
  async CreateSupport(data) {

    try {
      const response = await axiosInstance.post(`/support/create`, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAllSupport() {
    try {
      const response = await axiosInstance.get(`/support/get`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetById(id) {
    try {
      const response = await axiosInstance.get(`/support/getbyid/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async UpdateSupport(id, data) {
    try {
      const response = await axiosInstance.put(`/support/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteSupport(id) {
    try {
      const response = await axiosInstance.delete(`/support/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetByHash(hash = "", givenBy = null) {
    try {
      const params = {};
      if (hash) params.hash = hash;
      if (givenBy) params.givenBy = givenBy;

      const response = await axiosInstance.get(`/support/getSupportsByHash`, {
        params
      });
      return response.data;
    } catch (error) {
      console.error("Error in GetByHash:", error);
      throw error;
    }
  }

   async MarkRead(id) {
    try {
      const response = await axiosInstance.patch(`/support/markread/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error in MarkRead:", error);
    }
  }
}

export default new SupportApi();
